let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bBqkj")).then(() => parcelRequire('6u7z1'));